export default {"src":"/_next/static/image/public/images/social_fb_white.7364fa5151062c34bcbf5c544831b1ef.svg","height":15,"width":8};